import { interpolationTheme } from '../utils/index.mjs';
import useTheme from './use-theme.mjs';

// src/hooks/use-sx-props.ts
var useSxProps = () => {
  const theme = useTheme();
  const mergeSxProps = (sx) => {
    return interpolationTheme(sx, theme);
  };
  return mergeSxProps;
};
var use_sx_props_default = useSxProps;

export { use_sx_props_default as default };
